import React from 'react';
import { Tile, TileCaption, TileLabel, TileValue } from '../styled';
import { parseConfig } from './config';
import { formatLoss } from './format';

// In-editor preview of the expected-loss tile. Pure render from config + data
// (data is fetched + embedded by the settings form); mirrors the exported tile.
export const ExpectedLossEditorBody: React.FC<{
  config: Record<string, unknown>;
  data: Record<string, unknown> | null;
}> = ({ config: rawConfig, data }) => {
  const config = parseConfig(rawConfig);
  const raw = data ? data[config.which] : null;
  const value = typeof raw === 'number' ? raw : null;
  const currency = config.currencyOverride ?? (typeof data?.currency === 'string' ? data.currency : null);
  const valueText = value == null ? '—' : formatLoss(value, currency);
  const caption = typeof data?.assessmentName === 'string' ? data.assessmentName : null;

  if (config.emphasis === 'compact') {
    return (
      <Tile $compact>
        <TileLabel>{config.label.toUpperCase()}</TileLabel>
        <TileValue $compact>{valueText}</TileValue>
      </Tile>
    );
  }

  return (
    <Tile>
      <TileLabel>{config.label.toUpperCase()}</TileLabel>
      <TileValue>{valueText}</TileValue>
      {caption ? <TileCaption>{caption}</TileCaption> : null}
    </Tile>
  );
};
